import { createSessionStore } from "@react/foundation/zustand";

import { logger } from "../../../bootstrap/logger.ts";
import { STORE_KEY, STORE_VERSION } from "../../../bootstrap/store.ts";

export const { sessionStore: connectSessionStore } = createSessionStore({
  logger,
  storeKey: STORE_KEY.githubConnectSession,
  storeVersion: STORE_VERSION,
});
